export default function Spinner({
	className = '',
	width = '20px',
	height = '20px',
	...props
}) {
	return (
		<svg
			className={`is-loading ${className}`}
			aria-hidden={true}
			height={height}
			width={width}
			viewBox="22 22 44 44"
		>
			<circle
				cx="44"
				cy="44"
				r="20.2"
				fill="none"
				stroke-width="3.6"
			/>
		</svg>
	);
}
